import React from 'react';
import { Icon } from 'antd';
import Button from 'Components/Shared/Button/Button';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import FormLoginContainer from 'Components/FormLogin/FormLoginContainer';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import WarningWrapper from 'Components/Shared/WarningWrapper/WarningWrapper';
import PickPackageContainer from 'Components/PickPackage/PickPackageContainer';
import PickVoucherContainer from 'Components/PickVoucher/PickVoucherContainer';
import PickDeliveryContainer from 'Components/PickDelivery/PickDeliveryContainer';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';
import FormCustomerInfoContainer from 'Components/FormCustomerInfo/FormCustomerInfoContainer';
import PickSkanetrafikenContainer from 'Components/PickSkanetrafiken/PickSkanetrafikenContainer';
import OrderCancelConfirm from 'Components/OrderCancelConfirm/OrderCancelConfirm';
import OrderVoucherSummaryContainer from 'Components/OrderVoucherSummary/OrderVoucherSummaryContainer';
import OrderSeatSummaryContainer from 'Components/OrderSeatSummary/OrderSeatSummaryContainer';
import OrderItemSummaryContainer from 'Components/OrderItemSummary/OrderItemSummaryContainer';

interface IProps {
  isRetry?: boolean;
  isFetching: boolean;
  isFetchFailed: boolean;
  isLoggedIn: boolean;
  isShowingWarning: boolean;
  isDeliverySet: boolean;
  isOrderSeatsEmpty: boolean;
  isOrderVouchersEmpty: boolean;
  isOrderValid: boolean;
  onNext: () => void;
  onBack: () => void;
}

const OrderDetailsPage: React.SFC<IProps> = ({
  isRetry,
  isFetching,
  isFetchFailed,
  isShowingWarning,
  isLoggedIn,
  isDeliverySet,
  isOrderSeatsEmpty,
  isOrderVouchersEmpty,
  onNext,
  onBack,
  isOrderValid,
}) => {

  if (isFetching) {
    return <Spinner height='lg'/>;
  }

  if (isFetchFailed || (isOrderSeatsEmpty && isOrderVouchersEmpty)) {
    return (
      <>
      <WrapperBox>
        <FormattedText
          displayName={
            `Vi kunde inte hitta några tillgängliga 
            biljetter... Försök gärna igen om en stund.'`
          }
          formattedName='order.message.noseats'
        />
      </WrapperBox>
      <div className='order-layout-footer'>
        <Button color='transparent' onClick={ onBack }>
          <Icon type='left' />
          <FormattedText
            displayName='Tillbaka'
            formattedName='order.button.previous'
          />
        </Button>
        </div>
      </>
    );
  }

  if (!isOrderValid) {
    return (
      <>
      <WrapperBox>
        <FormattedText
          displayName={
            `Valt antal biljetter matchar inte biljettypens inställningar. Var vänlig försök igen.'`
          }
          formattedName='order.message.invalid'
        />
      </WrapperBox>
      <div className='order-layout-footer'>
        <Button color='transparent' onClick={ onBack }>
          <Icon type='left' />
          <FormattedText
            displayName='Tillbaka'
            formattedName='order.button.previous'
          />
        </Button>
        </div>
      </>
    );
  }
  
  return (
    <>
      { isRetry ?
        <>
          <OrderItemSummaryContainer />
          <PickDeliveryContainer />
        </> :
        <>
          <OrderSeatSummaryContainer />
          <OrderVoucherSummaryContainer />
          <PickSkanetrafikenContainer />
          <PickPackageContainer />
          { isOrderVouchersEmpty &&
            <PickVoucherContainer />
          }
          <PickDeliveryContainer />
        </>
      }
      { !isLoggedIn &&  
          <WrapperBox>
            <FormLoginContainer { ... { showCreateOption: false } } />
          </WrapperBox>
        }
        { isDeliverySet &&
          <FormCustomerInfoContainer />
        }
      <div className='order-layout-footer'>
        <OrderCancelConfirm 
          placement='top'
          triggerType='back-click' 
          onConfirm={ onBack } 
        >
          <Button color='transparent'>
            <Icon type='left' />
            <FormattedText
              displayName='Tillbaka'
              formattedName='order.button.previous'
            />
          </Button>
        </OrderCancelConfirm>
        <WarningWrapper
          isShowingWarning={ isShowingWarning }
          displayName={ 
            isDeliverySet ? 
            'Fyll i dina uppgifter' : 
            'Välj leveransmetod' 
          }
          formattedName={ 
            isDeliverySet ? 
            'order.customer.warning' : 
            'order.delivery.warning'
          }
        >
          <Button onClick={ onNext }>
            <FormattedText
              displayName='Till betalning'
              formattedName='order.button.payment'
            />
            <Icon type='right' />
          </Button>
        </WarningWrapper>
      </div>
    </>
  );
};

export default OrderDetailsPage;


// WEBPACK FOOTER //
// ./src/pages/OrderDetailsPage/OrderDetailsPage.tsx